function CustomerDetails() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Project.Details visual. <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added support for more buttons                                   *<br />
    /// * - documentation                                   *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
CustomerDetails.prototype = new vcTemplate();
CustomerDetails.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.initClickHandler();
        me.visual.find(".button-toggle-active").trigger("click");
        return true;
    } catch (ex) {
        me.writeError('CustomerDetails.init', ex);
        return false;
    }
};

CustomerDetails.prototype.loadDetailForms = function () {
    /// <summary>
    /// This function is used for the various options in the logger/project/customer detailview. <br/>
    /// Currently the following types are supported <br/>
    /// <list type="bullet">
    /// <item>
    /// <description>'logger' loads the logger and device form</description>
    /// </item>
    /// <item>
    /// <description>'customer' loads the customer form</description>
    /// </item>
    /// <item>
    /// <description>'location' loads the geocoding widget</description>
    /// </item>
    /// <item>
    /// <description>'user2logger' assignment of users to the current logger</description>
    /// </item>
    /// <item>
    /// <description>'rights2project' assignments of right-groups to the current logger</description>
    /// </item>
    /// <item>
    /// <description>'logger2bec' unused, but planned for Project Assignments to Brands</description>
    /// </item>
    /// <item>
    /// <description>'loggerDel' unused, but planned for deletion of logger</description>
    /// </item>
    /// </list> 
    /// </summary>
    var me = this;
    var type;
    try {
        if (me.error) {
            return false;
        }
        //init list entry click handler
        type = me.visual.find('.button-toggle-active').attr("data-projectdetail");
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        me.visual.find("#detailContent").html(me.vcC.getLoadingIcon());
       
        switch (type) {
            
        
            case "customer":
                me.vcVisual.addVisualBaseByName('d', 'WIDGET_PROJECT_CUSTOMERFORM', 'etailContent', window.getCurrentTimestamp(), me.height-100, me.width, '', JSON.stringify({ 'customerid': me.ids.customerid }), me.deviceType);
                break;
            //case "design":

            //    me.vcVisual.addVisualBaseByName('de', 'VISUAL_MEMBERSHIP_ASSIGNMENT_CREDENTIALS2CUSTOMER', 'tailContent', getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), JSON.stringify({ 'AssID': me.ids.customerid }), '', me.deviceType);
            //    break;
            case "custDel":
                me.visual.find("#detailContent").html("Nur KUNDE LÖSCHEN (VORSICHT)");
                break;
            default:
                me.visual.find("#detailContent").html("button unbekannt");
                break;
        }

        return true;
    } catch (ex) {
        me.writeError("CustomerDetails.loadDetailForms", ex);return false;
    }
};

CustomerDetails.prototype.doEvent = function () {
    ////CURRENTLY DOES NOTHING JUST HERE TO AVOID ERRORS
};

CustomerDetails.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// by calling the webservice and calling the overview list again, needs to be 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.hide();
        window._VCMQ.produce(me.visual, me.vcgid, 'CUST_DET_BACK', {});
        return true;
    } catch (ex) {
        me.writeError('CustomerDetails.btnBack', ex);
        return false;
    }
};
CustomerDetails.prototype.initClickHandler = function () {
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.visual.find('#divBackFromDetailsToProjectOverview').button().off("click").on("click", function () {
            me.btnBack();
        });
        me.visual.find(".button-toggle").button().off("click").on("click", function () {
            me.visual.find(".button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.loadDetailForms();
        });
        return true;
    } catch (ex) {
        me.writeError('CustomerDetails.initClickHandler', ex);
        return false;
    }
};

CustomerDetails.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state.
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.toggle-button, #divContent').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};

